import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import { store } from './store/store'
import router from './router'
import VModal from 'vue-js-modal'
import vSelect from 'vue-select'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import 'vue-select/dist/vue-select.css';
import SkeletonCards from 'vue-ultimate-skeleton-cards'
import VuePictureSwipe from 'vue-picture-swipe';
import vueDebounce from 'vue-debounce'
import VueTippy from "vue-tippy";
import VueClipboard from 'vue-clipboard2'

import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'
import VueMeta from 'vue-meta'

// import '@/styles/_variables.scss';
// import '@/styles/_reset.scss';
// import '@/styles/_typography.scss';
// import '@/styles/_mixins.scss';

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

Vue.use(Vuelidate);
Vue.use(VModal);
Vue.use(Toast);
Vue.use(SkeletonCards);
Vue.use(vueDebounce)
Vue.use(VueTippy);
Vue.use(VueClipboard);
Vue.use(VueFusionCharts, FusionCharts, Charts, FusionTheme)
Vue.use(VueMeta)

Vue.component('v-select', vSelect)
Vue.component('vue-picture-swipe', VuePictureSwipe)

Vue.directive('click-outside', {
	bind: function (el, binding, vnode) {
		window.event = function (event) {
			if (!(el == event.target || el.contains(event.target))) {
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener('click', window.event)
	},
	unbind: function () {
		document.body.removeEventListener('click', window.event)
	},
});

if(process.env.VUE_APP_DEVTOOLS === '1'){
	Vue.config.devtools = true;
} else {
	Vue.config.devtools = false;
	Vue.config.debug = false;
	Vue.config.silent = true; 
}

// const app = new Vue({
new Vue({
	el: '#app',
	store,
	router,
	render: h => h(App)
});